<script>
import {
  iButton,
  iKeyIcon,
  iKeyIconSize,
  iKeyIconType,
  iKeyIconShape,
} from '@inscribe/signal';

export default {
  components: { iButton, iKeyIcon },
  props: {
    icon: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    subtitle: {
      type: String,
      default: null,
    },
    buttonText: {
      type: String,
      default: null,
    },
    secondaryButtonText: {
      type: String,
      default: null,
    },
    mainButtonDataTestId: {
      type: String,
      default: 'empty-page-main-button-testid',
    },
  },
  data() {
    return {
      iKeyIcon,
      iKeyIconSize,
      iKeyIconType,
      iKeyIconShape,
    };
  },
  methods: {
    onClick() {
      this.$emit('on-button-click');
    },
    onSecondaryClick() {
      this.$emit('on-secondary-button-click');
    },
  },
};
</script>

<template>
  <div
    class="empty-page d-flex flex-column align-items-center justify-content-center i-radius-3xl i-p-11"
  >
    <div class="content d-flex flex-column align-items-center i-gap-8">
      <i-key-icon
        :size="iKeyIconSize.XXL"
        :icon="icon"
        :type="iKeyIconType.NEUTRAL"
        :shape="iKeyIconShape.SQUARE"
      ></i-key-icon>

      <div class="text d-flex flex-column align-items-center i-gap-2">
        <div class="title i-text-neutral-120 i-text-heading-5">{{ title }}</div>
        <div class="subtitle i-text-neutral-110 i-text-body-2">
          {{ subtitle }}
        </div>
      </div>
      <div class="buttons-container d-flex flex-row i-gap-4">
        <i-button
          v-if="secondaryButtonText"
          :text="secondaryButtonText"
          type="neutral"
          subtype="outline"
          size="md"
          @button-click="onSecondaryClick"
        ></i-button>
        <i-button
          v-if="buttonText"
          :text="buttonText"
          :data-testid="mainButtonDataTestId"
          size="md"
          @button-click="onClick"
        ></i-button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.empty-page {
  border: 1px solid $light-neutral-60;
  height: 100%;

  .subtitle {
    text-align: center;
  }
}
</style>
